module.exports = __webpack_public_path__ + "img/logo-metro-blanco.688e1e85.png";